import React, { useEffect, useRef, useState } from 'react'

export const RangeSliderNewWh = ({ elems, onChangeMin, onChangeMax, defaultValueMin, defaultValueMax }) => {

  const range = useRef(null);
  const step = Number.parseFloat(100 / (elems.length - 1)).toFixed(2);
  const [valueMin, setValueMin] = useState(defaultValueMin ? defaultValueMin * step : 0);
  const [valueMax, setValueMax] = useState(defaultValueMax ? defaultValueMax * step : 0);
  const [rangeStyle, setRangeStyle] = useState({ left: `${valueMin}%`, width: `${valueMax - valueMin}%` });

  useEffect(() => {
    setValueMin(defaultValueMin ? defaultValueMin * step : 0);
    setValueMax(defaultValueMax ? defaultValueMax * step : 0);
  }, [defaultValueMin, defaultValueMax, step]);

  function handleOnChangeMin(e) {
    const v = parseFloat(e.target.value);
    if (v < valueMax) {
      setValueMin(v);
      onChangeMin(Math.floor(v / step));
    }
  }

  function handleOnChangeMax(e) {
    const v = parseFloat(e.target.value);
    if (v > valueMin) {
      setValueMax(v);
      onChangeMax(Math.floor(v / step));
    }
  }

  useEffect(() => {
    handleOnChangeMin({ target: { value: valueMin } });
    handleOnChangeMax({ target: { value: valueMax } });
  }, [valueMin, valueMax]);

  useEffect(() => {
    setRangeStyle({ left: `${valueMin}%`, width: `${valueMax - valueMin}%` });
  }, [valueMin, valueMax]);

  return (
    <div className='range__wrapper'>
      <div className="container-range-slider">
        <input
          value={valueMin}
          type="range"
          min={0}
          max={100}
          onChange={handleOnChangeMin}
          className="thumb thumb--left"
          step={step}
        />
        <input
          value={valueMax}
          type="range"
          min={0}
          max={100}
          step={step}
          onChange={handleOnChangeMax}
          className="thumb thumb--right"
        />

        <div className="slider">
          <div className="slider__track" />
          <div ref={range} style={rangeStyle} className="slider__range" />
        </div>
      </div>
      <div className="rangeSlider__items--wrapper">
        <div className="rangeSlider__items--bottom">
          {elems.map((el, i) =>
            <span key={i} className="text-xxs">{el}</span>
          )}
        </div>
      </div>
    </div>
  )
}
